import { render, staticRenderFns } from "./SpecialitySelect.vue?vue&type=template&id=90e090aa&"
import script from "./SpecialitySelect.vue?vue&type=script&lang=js&"
export * from "./SpecialitySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports